import {
  Box,
  Divider,
  Hidden,
  Page,
  PageBlock,
  Stack,
} from 'braid-design-system';

import { FaqAccordion } from 'src/components/FaqAccordion/FaqAccordion';
import Header from 'src/components/Header/Header';
import { SiteWideFooter } from 'src/components/SiteWideFooter';

import { faqs } from './components/FaqContent';
import { PackagesContainer } from './components/Packages';

const PackagesPage = () => (
  <Page footer={<SiteWideFooter />} footerPosition="belowFold">
    <Header title="Sell your business" />

    <Hidden below="tablet">
      <Divider />
    </Hidden>

    <Box paddingTop="xlarge">
      <PageBlock width="large">
        <Stack space="xxxlarge">
          <PackagesContainer />

          <FaqAccordion faqs={faqs} />
        </Stack>
      </PageBlock>
    </Box>
  </Page>
);

export default PackagesPage;
